import { KarticaVisitoraPage } from "../pages/kartica-visitora/kartica-visitora.page";

export class BirthDay {
    [x: string]: any;

    roomId: number;
    city: string;
    BirthdayZoneId: number;
    VisitorId: number;
    EmployeeId: number;
    Discount: number;
    advancePaymentWill: number;
    advancePaymentWillString: string;
    AdvancePayment: number;   
    CallDate: Date;
    AppointmentDate: string;
    PricePerChildren:number;   
    PlannedChildNumber: number
    PresentChildNumber: number
   
    TotalPricePaid: number;
    TotalPricePaidWithoutDicount:number;
    CallStatus: number
    startTimeBirthday: string;
    endTimeBirthday: string;
    BirthDayStartDt: Date;
    BirthDayEndsDt: Date
    BirthDayStart: string;
    BirthDayEnds: string
    SavedTimeSlotId: number;
    isFlexible: boolean;
    SavedTimeEndSlotId: number;
    NumberOfBirthday: number;
    TotalPricePaidWithAdds: number;
    TotalPricePaidAdds: number;
    AddsTotalNamePrices: { name: string; quantity: string; price: number; }[];
    CommentBirthdayAppointment:string;

    constructor() {

        this.roomId = null;
        this.city = '';
        this.BirthdayZoneId = null;
        this.VisitorId = null;
        this.EmployeeId = null;
        this.EmployeeName = "";
        this.Discount = 0;
        this.advancePaymentWill = null;
        this.advancePaymentWillString = "1";
        this.AdvancePayment = 0;      
        this.CallDate = null;
        this.AppointmentDate = null;
        this.PricePerChildren =null;       
        this.PlannedChildNumber = null
        this.PresentChildNumber = null
       
        this.TotalPricePaid = null;
        this.TotalPricePaidWithoutDicount=null;
        this.CallStatus = null;
        this.BirthDayStartDt = null;
        this.BirthDayEndsDt = null
        this.BirthDayStart = '';
        this.BirthDayEnds = '';
        this.startTimeBirthday = ''
        this.endTimeBirthday = ''
        this.isisAddBirthay = false
        this.SavedTimeSlotId = null
        this.isIsFlexible = false;
        this.SavedTimeEndSlotId = null;
        this.NumberOfBirthday = null;
        this.TotalPriceWithAdds = null;
        this.TotalPriceAdds = null;
        this.AddsTotalNamePrices = [];
        this.CommentBirthdayAppointment="";

    }
}